import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRecoilValue } from 'recoil';
import { personalizationState } from '../../../../../recoil-store/recoil-state';
import { convertToDateFormat } from '../../../../../helpers/helper';
export const createArray = (key, value) => {
    return { key, value }
}

let rowItems = [];

function MateInfo(props) {
    const { t } = useTranslation();
    const personalization = useRecoilValue(personalizationState);
    const [loaded, setLoaded] = useState(false)

    useEffect(() => {
        rowItems = [
            createArray('CONTENT.MY-MATES.MATE.MATE-BODY.DEVICE-NAME', props.data.device_name),
            createArray('CONTENT.MY-MATES.MATE.MATE-BODY.STATUS', props.data.status),
            createArray('CONTENT.MY-MATES.MATE.MATE-BODY.VERSION', props.data.version),
            createArray('CONTENT.MY-MATES.MATE.MATE-BODY.CREATED-BY', props.data.created_by_fullname),
            createArray('CONTENT.MY-MATES.MATE.MATE-BODY.CREATED-AT', convertToDateFormat(props.data.created_at, personalization.date_format)),
            createArray('CONTENT.MY-MATES.MATE.MATE-BODY.LAST-UPDATE-AT', convertToDateFormat(props.data.updated_at, personalization.date_format))
        ]
        setLoaded(true)
    }, [])

    return (
        <div className="info-body-detail">
            {
                loaded && rowItems.map((item, itemI) => {
                    return (
                        <div key={itemI} className='info-body-row'>
                            <div className='info-body-row-key'>
                                {t(item.key)}
                            </div>
                            <div className={itemI === 1 ? "status-success" : "info-body-row-value"}>
                                {item.value}
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}

export default MateInfo
